<template>
    <svg aria-hidden="true" focusable="false" width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="17" cy="17" r="17" fill="white" />
        <path
            d="M11.5384 13.967H8.85737C8.38368 13.967 8 14.3507 8 14.8244V19.2723C8 19.746 8.38368 20.1297 8.85737 20.1297H11.9032C12.1447 20.1297 12.3863 20.1628 12.6184 20.2339L18.2789 24.0707C18.8284 24.2318 19.3732 23.8197 19.3732 23.2512V10.8549C19.3732 10.2818 18.8237 9.87441 18.2789 10.0355L12.9689 13.7728C12.5 13.896 12.0168 13.967 11.5384 13.967Z"
            stroke="black"
            stroke-miterlimit="10" />
        <path d="M22.7173 12.2002C24.6405 12.9723 26 14.8481 26 17.046C26 19.2486 24.631 21.1291 22.7031 21.8965" stroke="black" stroke-miterlimit="10" stroke-linecap="round" />
        <path d="M22.7031 21.8965C24.6358 21.1291 26 19.2486 26 17.046C26 14.8481 24.6405 12.9723 22.7173 12.2002" stroke="black" stroke-miterlimit="10" stroke-linecap="round" />
        <path
            d="M22.0731 13.8154C23.3568 14.327 24.2615 15.5823 24.2615 17.046C24.2615 18.5144 23.352 19.7696 22.0636 20.2812"
            stroke="black"
            stroke-miterlimit="10"
            stroke-linecap="round" />
        <path
            d="M22.059 20.2812C23.3474 19.7696 24.2569 18.5144 24.2569 17.046C24.2569 15.5823 23.3521 14.3317 22.0684 13.8154"
            stroke="black"
            stroke-miterlimit="10"
            stroke-linecap="round" />
    </svg>
</template>
